// extracted by mini-css-extract-plugin
module.exports = {"userInfo":"Style_userInfo__p2lpL","dropdownMenu":"Style_dropdownMenu__2kXGF"};